import Container from "../Container";
import StepItem from "../StepItem";

export default function SectionSteps({children, items, className = ''}) {
    return (
        <Container className={`flex flex-col gap-10 ${className}`}>
            <header>
                {children}
            </header>
            <div className="w-full grid md:grid-cols-2 gap-x-5 gap-y-9 md:gap-y-20 max-w-[1000px] mx-auto">
                {items.map((item, key) => {
                    return (
                        <StepItem key={`StepItem: ${key}`}
                                  {...item}
                                  className={key % 2 !== 0 ? 'md:pt-16' : ''}
                        />
                    )
                })}
            </div>
        </Container>
    )
}